const defaultOrigin =
  typeof window !== 'undefined' ? window.location.origin : 'https://asror.clinix.kg';

/** CRM-инстансы по филиалам (переключение в шапке у директора). */
export const CLINIC_BRANCHES = [
  {
    label: 'DEM CLINIC · Основной',
    url: process.env.REACT_APP_BRANCH_MAIN_URL || defaultOrigin,
  },
  ...(process.env.REACT_APP_BRANCH_SECONDARY_URL
    ? [
        {
          label:
            process.env.REACT_APP_BRANCH_SECONDARY_LABEL || 'DEM CLINIC · Филиал 2',
          url: process.env.REACT_APP_BRANCH_SECONDARY_URL,
        },
      ]
    : []),
];

export function getBranchHostname(branchUrl) {
  try {
    return new URL(branchUrl, defaultOrigin).hostname;
  } catch {
    return '';
  }
}

export function isCurrentBranch(branchUrl, hostname) {
  const host = getBranchHostname(branchUrl);
  if (!host) return branchUrl === '/' || branchUrl === '';
  return host === hostname;
}
